/**
 * Web-side mirror of scan candidate count constants.
 *
 * Source of truth: src/lib/config.ts (scanConfig).
 * These values are intentionally hard-coded mirrors — the server clamp
 * (scanConfig.maxCount via POST /api/scan) is the authority; a client
 * sending a larger value will be silently clamped server-side. Update
 * both files together if the defaults change.
 */

/** Default number of scene candidates to request in a scan. */
export const SCAN_DEFAULT_COUNT = 3;

/** Server-enforced upper bound on candidate count. */
export const SCAN_MAX_COUNT = 10;

/** Preset chip values shown in the NewJob count control. The custom number
 *  input beside the chips accepts any value 1–SCAN_MAX_COUNT. */
export const SCAN_PRESET_COUNTS: readonly number[] = [2, 3, 5, 10];
